<template>
  <div
    class="
      tw-absolute
      tw-z-0
      tw-left-0
      tw-top-0
      tw-bottom-0
      tw-right-0
      tw-bg-sf-primary-subtle
      tw-rounded
    "
    data-testid="tree-menu-accent"
  ></div>
</template>
<script setup lang="ts"></script>
